var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxer2On({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/uxer_2_on"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.339 9.553V9.14c0-4.219 3.423-7.639 7.647-7.639 4.223 0 7.647 3.42 7.647 7.639v.414m-15.294 0h-.173C2.398 9.553 1 11.023 1 12.793c0 1.77 1.398 3.24 3.166 3.24h.21c.387 3.48 3.674 6.467 7.61 6.467 3.935 0 7.222-2.988 7.609-6.467h.24c1.767 0 3.165-1.47 3.165-3.24 0-1.77-1.398-3.24-3.166-3.24h-.201m-15.294 0v6.48m15.294-6.48v6.48m0-.684h-4.748a2.181 2.181 0 0 1-1.409-.516 2.181 2.181 0 0 0-2.818 0 2.181 2.181 0 0 1-1.408.516H4.339m10.982 2.152c-.462 1.398-1.865 2.354-3.457 2.354a3.772 3.772 0 0 1-2.525-.945m4.598-15.135-3.874 3.387m0-3.387 3.874 3.387m-3.325 3.313c0-2.073-2.582-2.073-2.582 0v.488c0 1.828 2.582 1.828 2.582 0v-.488Zm5.236 0c0-2.073-2.582-2.073-2.582 0v.488c0 1.828 2.582 1.828 2.582 0v-.488Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxer2On);
export default __webpack_public_path__ + "static/media/uxer_2_on.29730bd941e9a32596783912215fc4d1.svg";
export { ForwardRef as ReactComponent };